/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListModelHardpointsParams,
  ModelHardpoint,
  ModelHardpointInput,
  ModelHardpoints,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Model Hardpoint
 */
export const createModelHardpoint = (
    modelHardpointInput: MaybeRefOrGetter<ModelHardpointInput>,
 signal?: AbortSignal
) => {
      modelHardpointInput = toValue(modelHardpointInput);

      return axiosClient<ModelHardpoint>(
      {url: `/model-hardpoints`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelHardpointInput, signal
    },
      );
    }




export const getCreateModelHardpointMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelHardpoint>>, TError,{data: ModelHardpointInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelHardpoint>>, TError,{data: ModelHardpointInput}, TContext> => {

const mutationKey = ['createModelHardpoint'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelHardpoint>>, {data: ModelHardpointInput}> = (props) => {
          const {data} = props ?? {};

          return  createModelHardpoint(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelHardpointMutationResult = NonNullable<Awaited<ReturnType<typeof createModelHardpoint>>>
    export type CreateModelHardpointMutationBody = ModelHardpointInput
    export type CreateModelHardpointMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create Model Hardpoint
 */
export const useCreateModelHardpoint = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelHardpoint>>, TError,{data: ModelHardpointInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelHardpoint>>,
        TError,
        {data: ModelHardpointInput},
        TContext
      > => {
      return useMutation(getCreateModelHardpointMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Hardpoints list
 */
export const listModelHardpoints = (
    params?: MaybeRefOrGetter<ListModelHardpointsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelHardpoints>(
      {url: `/model-hardpoints`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelHardpointsQueryKey = (params?: MaybeRefOrGetter<ListModelHardpointsParams>,) => {
    return [
    'model-hardpoints', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelHardpointsQueryOptions = <TData = Awaited<ReturnType<typeof listModelHardpoints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelHardpointsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelHardpoints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelHardpointsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelHardpoints>>> = ({ signal }) => listModelHardpoints(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelHardpoints>>, TError, TData>
}

export type ListModelHardpointsQueryResult = NonNullable<Awaited<ReturnType<typeof listModelHardpoints>>>
export type ListModelHardpointsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Hardpoints list
 */

export function useListModelHardpoints<TData = Awaited<ReturnType<typeof listModelHardpoints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelHardpointsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelHardpoints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelHardpointsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Model Hardpoint
 */
export const destroyModelHardpoint = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/model-hardpoints/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelHardpointMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelHardpoint>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelHardpoint>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyModelHardpoint'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelHardpoint>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyModelHardpoint(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelHardpointMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelHardpoint>>>

    export type DestroyModelHardpointMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy Model Hardpoint
 */
export const useDestroyModelHardpoint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelHardpoint>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelHardpoint>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyModelHardpointMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Model Hardpoint
 */
export const modelHardpoint = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelHardpoint>(
      {url: `/model-hardpoints/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelHardpointQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-hardpoints',id
    ] as const;
    }


export const getModelHardpointQueryOptions = <TData = Awaited<ReturnType<typeof modelHardpoint>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelHardpoint>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelHardpointQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelHardpoint>>> = ({ signal }) => modelHardpoint(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelHardpoint>>, TError, TData>
}

export type ModelHardpointQueryResult = NonNullable<Awaited<ReturnType<typeof modelHardpoint>>>
export type ModelHardpointQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Model Hardpoint
 */

export function useModelHardpoint<TData = Awaited<ReturnType<typeof modelHardpoint>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelHardpoint>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelHardpointQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Hardpoint
 */
export const updateModelHardpoint = (
    id: MaybeRefOrGetter<string>,
    modelHardpointInput: MaybeRefOrGetter<ModelHardpointInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelHardpointInput = toValue(modelHardpointInput);

      return axiosClient<ModelHardpoint>(
      {url: `/model-hardpoints/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelHardpointInput, signal
    },
      );
    }




export const getUpdateModelHardpointMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelHardpoint>>, TError,{id: string;data: ModelHardpointInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelHardpoint>>, TError,{id: string;data: ModelHardpointInput}, TContext> => {

const mutationKey = ['updateModelHardpoint'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelHardpoint>>, {id: string;data: ModelHardpointInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelHardpoint(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelHardpointMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelHardpoint>>>
    export type UpdateModelHardpointMutationBody = ModelHardpointInput
    export type UpdateModelHardpointMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Model Hardpoint
 */
export const useUpdateModelHardpoint = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelHardpoint>>, TError,{id: string;data: ModelHardpointInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelHardpoint>>,
        TError,
        {id: string;data: ModelHardpointInput},
        TContext
      > => {
      return useMutation(getUpdateModelHardpointMutationOptions(options), queryClient);
    }
